const styles = `:host {
  --goto-icon-color: var(--goto-nav-drawer-icon-color);
  --goto-icon-size: var(--goto-spacing-04);
  border-width: 1px;
  border-style: solid;
  outline: 0;
  cursor: pointer;
  border-color: transparent;
  display: inline-flex;
  align-items: center;
  height: 36px;
  padding: 0 var(--goto-spacing-05);
  box-sizing: border-box;
}
:host .content {
  font: var(--goto-body-small);
  color: var(--goto-text-01);
  display: block;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
:host [name=start]::slotted(*) {
  margin-right: var(--goto-spacing-04);
}
:host [name=end]::slotted(*) {
  margin-left: var(--goto-spacing-04);
}
:host .start,
:host .end {
  align-items: center;
  display: flex;
}

:host(:focus-visible) {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}

:host(:hover) {
  background-color: var(--goto-hover-secondary);
}

:host(:active) {
  background-color: var(--goto-pressed-secondary);
}

:host([selected]) {
  --goto-icon-color: var(--goto-nav-drawer-item-icon-color-selected);
  background-color: var(--goto-nav-drawer-item-background-selected);
}
:host([selected]) .content {
  color: var(--goto-text-04);
  --goto-icon-color: var(--goto-text-04);
}

:host([disabled]),
:host([disabled]:hover) {
  --goto-icon-color: var(--goto-text-03);
  background-color: transparent;
}
:host([disabled]) .content,
:host([disabled]:hover) .content {
  color: var(--goto-disabled-03);
  --goto-icon-color: var(--goto-disabled-03);
}
:host([disabled]) ::slotted(svg),
:host([disabled]:hover) ::slotted(svg) {
  color: var(--goto-text-03);
}

:host([size=small]) {
  height: var(--goto-spacing-06);
}
:host([size=small]) .content {
  font: var(--goto-caption-default-01);
}

:host([size=large]) {
  height: 44px;
  margin: 0.25rem 0.5rem;
  border-radius: 4px;
  padding: 0 12px;
}
:host([size=large]) .content {
  font: var(--goto-body-medium);
}`; export default styles;